<template>
  <b-container>
    <div class="d-flex flex-wrap flex-md-nowrap align-items-center pb-2 justify-content-between">
      <TheTitle>主頁</TheTitle>
    </div>
    <div class="section-wrapper" v-if="isPremium">
      <CouponOverview v-if="isPremium"
                      :isPremium="isPremium"
                      :loading="loading"
                      :couponOverview="couponOverview"
                      @updateDateRange="updateDateRange">
      </CouponOverview>
    </div>
    <div class="section-wrapper" v-if="notificationList && withdrawalOverview && couponOverview">
      <Notifications :role="role"
                     :notificationList="notificationList">
      </Notifications>
      <Advertisements v-if="role === 'merchant' && !!user.communityId">
      </Advertisements>
      <WithdrawalOverview v-if="isPremium"
                          :role="role"
                          :loading="loading"
                          :withdrawalOverview="withdrawalOverview">
      </WithdrawalOverview>
      <CouponOverview v-if="!isPremium"
                      :role="role"
                      :loading="loading"
                      :couponOverview="couponOverview"
                      @updateDateRange="updateDateRange">
      </CouponOverview>
    </div>
    <section class="table-content" v-if="couponList">
      <div class="listing-title">最新動態</div>
      <template v-if="isEmptyState && role === 'merchant'">
        <CouponEmptyState :role="role"
                          :isHomeEmptyState="isHomeEmptyState"
                          :userClass="userClass"></CouponEmptyState>
      </template>
      <template v-else>
        <DataTable
          v-show="couponList.list.result"
          :fields="fields"
          :mobileFields="mobileFields"
          :items="couponList.list.result"
          :options.sync="options"
          :loading="loading"
          @row-clicked="goToItem"
          @row-selected="onRowSelected"
          :disableItemPerPage="disableItemPerPage"
          thead-class="d-none"
        >
          <template v-slot:cell(id)="{ item }">
            <div class="d-flex">
              <img v-if="item.cover" class="data-table__cover ml-2" :src="item.cover" />
              <div class="d-flex flex-column justify-content-center">
                {{ item.id }}
              </div>
            </div>
          </template>
          <template v-slot:cell(useUFun)="{ value }">
            <div>
              <span v-if="value">積分優惠券</span>
              <span v-else>付費優惠券</span>
            </div>
          </template>
          <template v-slot:cell(status)="{ value }">
            <StatusLabel :item="value"></StatusLabel>
          </template>

          <template v-slot:cell(mobile)="{ item }">
            <div class="d-flex justify-content-between">
              <div class="d-flex">
              <img v-if="item.cover" class="data-table__cover mx-2" :src="item.cover" />
                <div class="d-flex flex-column">
                  <div>
                    <span class="mr-1 text-secondary">參考編號</span>
                    <router-link
                      :to="{ path: `${item.useUFun ? '/coupons' : '/paidCoupons'}/${item.id}` }"
                    >
                      {{ item.id }}
                    </router-link>
                    <template>
                      <span class="m-1 text-secondary" v-if="item.useUFun">積分優惠券</span>
                      <span class="m-1 text-secondary" v-else>付費優惠券</span>
                    </template>
                  </div>
                  <div class="data-table-mobile-row__title">{{ item.name1 }}</div>
                  <div>
                    <span class="text-secondary mr-1">
                      狀態更新為
                    </span>
                    <StatusLabel :item="getCouponStatus(item.status)"></StatusLabel>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-content-end">
                <span class="text-secondary mr-2 data-table-mobile-row__date">
                  <div class="text-right">
                    {{ item.updatedAt.split(" ")[0] }}
                  </div>
                  <div class="text-right">
                    {{ item.updatedAt.split(" ")[1] }}
                  </div>
                </span>
              </div>
            </div>
          </template>

        </DataTable>
      </template>
    </section>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  tap, map, switchMap, debounceTime, pluck, mergeAll,
} from 'rxjs/operators';
import {
  BContainer,
} from 'bootstrap-vue';
import CouponEmptyState from '@/components/coupon/CouponEmptyState.vue';
import WithdrawalOverview from '@/views/home/WithdrawalOverview.vue';
import Notifications from '@/views/home/Notifications.vue';
import Advertisements from '@/views/home/Advertisements.vue';
import CouponOverview from '@/views/home/CouponOverview.vue';
import imagePath from '@/filters/image-path';
import dataTableMixin from '../../mixins/data-table';
import TheTitle from '../../components/TheTitle.vue';
import StatusLabel from '../../components/StatusLabel.vue';
import getCouponStatus from '../../helpers/coupon-status';
import DataTable from '../../components/DataTable.vue';

export default {
  mixins: [dataTableMixin],
  components: {
    TheTitle,
    BContainer,
    CouponOverview,
    WithdrawalOverview,
    Notifications,
    Advertisements,
    StatusLabel,
    DataTable,
    CouponEmptyState,
  },
  data: () => ({
    merchantName: null,
    filter: {
      keywordType: 'all',
      status: undefined,
    },
    options: {
      // sortBy: 'id',
    },
    selected: [],
    disableItemPerPage: true,
    dateRange: '',
    isHomeEmptyState: true,
    keyword: '',
    mobileFields: [
      {
        key: 'mobile',
        thStyle: {
          display: 'none',
        },
      },
    ],
  }),
  computed: {
    ...mapGetters(['role']),
    isEmptyState() {
      return this.couponList.list.total === 0;
    },
    fields() {
      return [
        { key: 'id', label: '參考編號', sortable: false },
        {
          key: 'useUFun',
          label: '類型',
          sortable: false,
        },
        { key: 'name1', label: '優惠名稱', sortable: false },
        {
          key: 'status',
          label: '狀態',
          sortable: false,
          formatter: (value, key, item) => getCouponStatus(item.status),
        },
        { key: 'updatedAt', label: '更新日期時間', sortable: false },
      ];
    },
    ...mapState(['user']),
    userClass() {
      return this.user.class;
    },
    isPremium() {
      return this.user.class === 'PREMIUM' || this.role === 'admin' || this.role === 'sale';
    },
  },
  domStreams: ['onOverviewSelect$', 'exportData$'],
  subscriptions() {
    const getCouponOverview$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/home/coupon/overview`,
    }, data);

    const getWithdrawalOverview$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/home/withdrawal/overview`,
    }, data);

    const getCouponList$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/home/coupon/listing`,
    }, data);

    const getNotificationList$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/home/notification`,
    }, data);

    const onDateRangeUpdate$ = this.$watchAsObservable('dateRange').pipe(
      pluck('newValue'),
      tap((dateRange) => {
        if (dateRange) {
          [this.filter.startDate, this.filter.endDate] = dateRange;
        } else {
          this.filter.startDate = null;
          this.filter.endDate = null;
        }
      }),
    );

    return {
      couponOverview: scheduled([
        ...this.scheduleTasks,
        onDateRangeUpdate$,
      ], asyncScheduler).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getCouponOverview$),
      ),
      couponList: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getCouponList$),
      ),
      withdrawalOverview: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getWithdrawalOverview$),
      ),
      notificationList: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        pluck('data'),
        switchMap(getNotificationList$),
      ),
    };
  },
  methods: {
    goToItem({ id, useUFun }) {
      this.$router.push({
        path: `${useUFun ? '/coupons' : '/paidCoupons'}/${id}`,
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    onOverviewItemClicked(status) {
      this.filter.status = status.toUpperCase();
    },
    updateDateRange(val) {
      this.dateRange = val;
    },
    getCouponStatus,
  },
  filters: {
    imagePath,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/data-table/list-table-content';

.listing-title {
  font-weight: 500;
  color: #174169;
  font-size: 18px;
  box-sizing: border-box;
  padding: 10px 20px;
}

.section-wrapper {
  width: 100%;
  display: flex;
  margin-bottom: 16px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }
}

.data-table {
  &-mobile-row {
    &__title {
        @media (max-width: 420px) {
        max-width: 13rem;
      }
    }

    &__date {
      font-size: 0.7rem;
      width: 3.6rem;
    }
  }
}
</style>
